import React from "react";
import { Layout, Menu } from "antd";
import { DashboardOutlined, BulbOutlined, ToolOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { bugReportHandle } from "../state/actions";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
const { Sider } = Layout;

function SideBar({ collapsed }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const param = new URLSearchParams(location.search);
  const type = param.get("type")

 
  const selectedKey = type === "SUGGESTIONS" ? "suggestions" : type === "SUPPORT" ? "support" : "listings";
  const onClick = ({ key }) => {
    dispatch(bugReportHandle.resetSearchData());
    const compType = key === "listings" ? "BUGS" : key === "suggestions" ? "SUGGESTIONS" : "SUPPORT";
    history.push(`/bugsReport?type=${compType}`);
  };

  return (
    <Sider
      trigger={null}
      breakpoint="sm"
      collapsedWidth="0"
      style={{
        backgroundColor: "white",
        marginTop: "20px",
        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        display: "flex",
        color: "#ffffff",
        justifyContent: "center",
        padding: "1rem 0rem 0 0.2rem",
        height: "95%",
      }}
    >
      <Menu onClick={onClick} selectedKeys={[selectedKey]} mode="inline">
        <Menu.Item key="listings" icon={<DashboardOutlined style={{ fontSize: collapsed ? "25px" : "18px" }} />}>
          <span style={{ fontWeight: "bold", fontFamily: "sans-serif" }}>BUG LISTINGS</span>
        </Menu.Item>
        <Menu.Item key="suggestions" icon={<BulbOutlined style={{ fontSize: collapsed ? "25px" : "18px" }} />}>
          <span style={{ fontWeight: "bold", fontFamily: "sans-serif" }}>SUGGESTIONS</span>
        </Menu.Item>
        <Menu.Item key="support" icon={<ToolOutlined style={{ fontSize: collapsed ? "25px" : "18px" }} />}>
          <span style={{ fontWeight: "bold", fontFamily: "sans-serif" }}>SUPPORT</span>
        </Menu.Item>
      </Menu>
    </Sider>
  );
}

export { SideBar };
